import React from 'react';
import Navbar from '../Navbar/Navbar';
import tabla from '../../tabla.png'
import InfoblokkSmall from '../../infoblokk-small.webp'
import { Link } from 'react-router-dom';

const LandingPage = () => {
  // Egyedi színpaletta definíciók az "Industrial Modern" stílushoz
  const theme = {
    darkSlate: '#1e293b',
    constructionOrange: '#f97316',
    lightGrey: '#f1f5f9',
    white: '#ffffff',
  };

  return (
    <div style={{ backgroundColor: theme.lightGrey, minHeight: '100vh', fontFamily: 'sans-serif' }}>
      
      {/* Fejléc / Hero Szekció */}
   <section className="hero is-medium" style={{ backgroundColor: theme.darkSlate, paddingTop: '4rem' }}>
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-1" style={{ color: theme.white, fontWeight: 'bold' }}>
              Sz. és Sz. Center Bt.
            </h1>
            <h2 className="subtitle is-4 mt-3" style={{ color: theme.constructionOrange }}>
              Megbízható építőipari és fuvarozási szolgáltatások
            </h2>
          </div>
        </div>
      </section>



      {/* Pályázat Szekció */}
{/* Pályázat Szekció */}
  <section className="section" id="palyazat" >
    <div className="container">
      <div className="columns is-centered">
        <div className="column is-10 has-text-centered">
          <h2 className="title is-3" style={{ color: theme.darkSlate }}>Nyertes Pályázatunk</h2>
          <div 
            style={{ width: '60px', height: '4px', backgroundColor: theme.constructionOrange, margin: '0 auto 2rem auto' }}
          ></div>
          <p className="mb-5" style={{ color: theme.darkSlate }}>
            A Széchenyi Terv Plusz program keretében megvalósuló projektünk részletei.
          </p>
                    <p className="mb-5" style={{ color: theme.darkSlate }}>
            Kattintson a részletekért!
          </p>
          
{/* Pályázati kép helye */}
<Link to="/szechenyi-terv-plusz">
  <figure 
    className="image is-inline-block mb-6" 
    style={{ 
      border: `2px solid ${theme.darkSlate}`, 
      borderRadius: '8px', 
      overflow: 'hidden', 
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)' 
    }}
  >
    <img 
      src={InfoblokkSmall} 
      alt="Széchenyi Terv Plusz Információs Tábla" 
      style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
    />
  </figure>
</Link>

        </div>
      </div>
    </div>
  </section>
        {/* Bemutatkozás Szekció */}
      <section className="section" id="bemutatkozas" style={{ backgroundColor: theme.white }}>
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-8 has-text-centered">
              <h2 className="title is-3" style={{ color: theme.darkSlate }}>Rólunk</h2>
              <div 
                style={{ width: '60px', height: '4px', backgroundColor: theme.constructionOrange, margin: '0 auto 2rem auto' }}
              ></div>
              <p className="content is-medium has-text-justified" style={{ color: theme.darkSlate, lineHeight: '1.8' }}>
                A 2007-ben alapított Sz. és Sz. Center Bt. kezdetben szárazépítéssel és festéssel állt 
                megrendelői rendelkezésére. Az elmúlt évek során folyamatosan fejlődtünk és reagáltunk 
                a piaci igényekre, így tevékenységi körünket gépi földmunkával és fuvarozással bővítettük. 
                Szolgáltatásaink palettája 2024-ben újabb mérföldkőhöz ért: gépparkunknak köszönhetően immár 
                mixerbeton-szállítást is vállalunk. Megbízható és precíz munkavégzésünkkel magánszemélyek 
                és vállalati ügyfelek számára egyaránt készséggel állunk rendelkezésre.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Kapcsolat Szekció */}
      <section className="section" id="kapcsolat">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-6">
              <div className="card" style={{ backgroundColor: theme.darkSlate, borderRadius: '12px' }}>
                <div className="card-content has-text-centered">
                  <h2 className="title is-3" style={{ color: theme.white }}>Kapcsolat</h2>
                  <div 
                    style={{ width: '60px', height: '4px', backgroundColor: theme.constructionOrange, margin: '0 auto 2rem auto' }}
                  ></div>
                  
                  <div className="content is-medium" style={{ color: theme.lightGrey }}>
                    <p>
                      <strong style={{ color: theme.constructionOrange }}>Cím:</strong><br />
                      6500 Baja, Szegedi út 112.
                    </p>
                    <p>
                      <strong style={{ color: theme.constructionOrange }}>E-mail:</strong><br />
                      <a href="mailto:ssbmltrockenbau@gmail.com" style={{ color: theme.white, textDecoration: 'underline' }}>
                        ssbmltrockenbau@gmail.com
                      </a>
                    </p>
                    <hr style={{ backgroundColor: 'rgba(255,255,255,0.1)', height: '1px' }} />
                    <p>
                      <strong style={{ color: theme.constructionOrange }}>Telefon:</strong><br />
                      Szabó József: <a href="tel:+36703321491" style={{ color: theme.white }}>+36 70 332 1491</a><br />
                      Szemes János: <a href="tel:+36703214411" style={{ color: theme.white }}>+36 70 321 4411</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lábjegyzet */}
      <footer className="footer" style={{ backgroundColor: theme.darkSlate, padding: '1.5rem 1.5rem 1.5rem', borderTop: `1px solid ${theme.constructionOrange}` }}>
        <div className="content has-text-centered" style={{ color: theme.lightGrey }}>
          <p>
            &copy; {new Date().getFullYear()} <strong style={{ color: theme.constructionOrange }}>Sz. és Sz. Center Bt.</strong> Minden jog fenntartva.
          </p>
        </div>
      </footer>

    </div>
  );
};

export default LandingPage;